import type { FC, ReactNode } from 'react';
import React from 'react';

import Tooltip from '@mui/material/Tooltip';

import styles from './index.module.scss';
export interface HeaderProps {
  title: ReactNode;
  className?: string;
  headerBorder?: boolean;
  leftButtons?: ReactNode[];
  rightButtons?: ReactNode[];
}

const Header: FC<HeaderProps> = (props) => {
  const { title, className, headerBorder = false, leftButtons, rightButtons } = props;

  const renderTitle = () => {
    if (typeof title === 'string') {
      return (
        <Tooltip
          title={title}
          arrow
          enterTouchDelay={0}
          slotProps={{
            tooltip: {
              className: styles.titleTooltip,
            },
          }}
        >
          <h1>{title}</h1>
        </Tooltip>
      );
    }
    return title;
  };

  return (
    <div className={`${styles.header} ${headerBorder ? styles.border : ''} ${className || ''}`}>
      <div>{leftButtons}</div>
      <div>{renderTitle()}</div>
      <div>{rightButtons}</div>
    </div>
  );
};

export default Header;
